
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/review/[courseId]",
      function () {
        return require("private-next-pages/review/[courseId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/review/[courseId]"])
      });
    }
  